export default Object.freeze({
  id: '',
  avatar: null,
  firstName: '',
  lastName: '',
  color: '#0fd21e',
  isGuestUser: false
});
